import React, { useState } from "react";
import { v4 as uuidv4 } from "uuid";
import Chart from "react-apexcharts";

// import {
// LearningContentsAndCompletionRate,
// LearningRecord,
// ComprehensiveEvaluation,
// } from "../components/report/ReportForm";
import Icon from "../components/common/Icon";
import { useQueryClient } from "react-query";
import { useLocationQuery } from "../util/common";
import { getReportData } from "../api";
import { useMount } from "react-use";
import Quiz from "../components/quiz/Quiz";
const COLORS = ["#8877D1", "#EDE171", "#82E4AB", "#5F9FF5"];

const ReportPage = () => {
  const queryClient = useQueryClient();
  const query = useLocationQuery();
  const { lecture_id, student_id, parent_id } = query;
  const [
    { attendance, student, lecture, completion, learning, quiz, total },
    setData,
  ] = useState({
    attendance: null,
    student: null,
    lecture: null,
    completion: null,
    learning: null,
    quiz: null,
    total: [],
  });

  const getDataQuery = async () => {
    const result = await queryClient.fetchQuery(["report/data"], {
      queryFn: () => getReportData({ lecture_id, student_id, parent_id }),
    });
    if (result.result) {
      setData(result.data);
    }
  };

  useMount(() => {
    getDataQuery();
  });

  return (
    <div className="bg-zinc-100 min-h-screen">
      <div className="mx-auto lg:max-w-screen-lg p-1 md:p-2 flex flex-col justify-center">
        {lecture && (
          <div className="mx-auto container rounded-t-lg md:rounded-t-2xl bg-cyan-500 px-6 pt-6 pb-4">
            <h1 className="break-keep text-2xl sm:text-3xl md:text-5xl leading-tight text-white font-bold">
              {lecture.name}
            </h1>
            <h3 className="break-keep mt-2 sm:text-xl text-white">
              {`${lecture.date} (${lecture.days}일 ${lecture.hours}시간)`}
            </h3>
          </div>
        )}
        {student && (
          <div className="mx-auto container flex flex-wrap xs:flex-row flex-col justify-between align-middle rounded-b-lg md:rounded-b-2xl bg-zinc-50 py-4 px-4 pt-6 pb-4">
            <div className="flex justify-start align-middle gap-1">
              <Icon
                name="academic-cap"
                className="lg:w-10 lg:h-10 w-8 h-8 self-center text-cyan-500 pb-1"
              />
              <h2 className="break-keep text-2xl self-center font-bold">
                {`${student.name} 학생`}
              </h2>
            </div>
            <div className="flex xs:flex-col xs:justify-end flex-row xs:gap-0 gap-1 xs:pl-0 pl-9">
              <h3 className="break-keep text-lg self-center">
                {student.school}
              </h3>
            </div>
          </div>
        )}
        <div className="mx-auto container grid grid-report gap-1 md:gap-2 my-1 md:my-2">
          {completion && (
            <div className="bg-white p-4 rounded-lg">
              <h3 className="text-lg font-bold">학습 리포트</h3>
              <div className="flex flex-col gap-1 mt-2">
                <div className="flex flex-row flex-wrap gap-1">
                  <div className="stat bg-zinc-100 rounded-md p-4 flex-grow flex-shrink basis-1/2">
                    <div className="stat-title opacity-100 font-bold">
                      총 학습 시간
                    </div>
                    <div className="stat-value text-cyan-500 text-3xl">
                      {learning.times}
                    </div>
                    <div className="stat-desc opacity-100">{`총 ${learning.hours}시간 수업 중 학습시간`}</div>
                  </div>
                  {learning && quiz && (
                    <div className="stat bg-zinc-100 rounded-md p-4 flex-grow flex-shrink basis-1/3">
                      <div className="stat-title opacity-100 font-bold">
                        총 출석율
                      </div>
                      <div className="stat-value text-cyan-500 text-3xl">
                        {`${completion.rate}%`}
                      </div>
                      <div className="stat-desc opacity-100">{`총 ${lecture.days}일간 수업 출석율`}</div>
                    </div>
                  )}
                </div>
                <div className="stat bg-zinc-100 rounded-md px-4">
                  <div className="stat-title opacity-100 font-bold">
                    학습 내용
                  </div>
                  <div className="flex justify-between flex-col">
                    {completion.list.map(({ subject, desc }, idx) => (
                      <div
                        tabIndex={0}
                        className={`collapse rounded-md mb-1 bg-chart-${idx}`}
                        style={{
                          minHeight: "2.75rem",
                        }}
                        key={uuidv4()}
                      >
                        <div className="collapse-title-chapter inline-flex items-center justify-between mix-blend-multiply">
                          {`${idx + 1}. ${subject}`}
                        </div>
                        <div className="collapse-content-chapter bg-opacity-70 bg-white pt-4 relative">
                          {desc &&
                            desc.map((v) => <p key={uuidv4()}>{`- ${v}`}</p>)}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-5 h-5 absolute bottom-0 left-0 right-0 m-auto mix-blend-difference"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="stat bg-zinc-100 rounded-md px-4 pb-0">
                  <div className="stat-title opacity-100 font-bold">
                    학습 출석
                  </div>
                  <div className="stat-value">
                    {attendance && (
                      <Chart
                        {...{
                          series: attendance.list,
                          options: {
                            chart: {
                              toolbar: {
                                show: false,
                              },
                            },
                            legend: {
                              show: false,
                            },
                            dataLabels: {
                              enabled: false,
                            },
                            plotOptions: {
                              heatmap: {
                                enableShades: true,
                                shadeIntensity: 0.2,
                                distributed: true,
                              },
                            },
                            tooltip: {
                              enabled: false,
                            },
                            colors: COLORS,
                            xaxis: {
                              type: "category",
                              categories: ["출석", "지각", "조퇴", "결석"],
                              position: "top",
                              labels: {
                                style: {
                                  fontWeight: 900,
                                },
                              },
                              axisBorder: {
                                show: false,
                              },
                              axisTicks: {
                                show: false,
                              },
                            },
                            yaxis: {
                              labels: {
                                style: {
                                  fontWeight: 900,
                                },
                              },
                            },
                            grid: {
                              borderColor: "#F4F4F5",
                              position: "front",
                            },
                          },
                          type: "heatmap",
                          height: 200,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
              {/* <LearningContentsAndCompletionRate
                items={[
                  { type: "collapse", list: completion.list },
                  {
                    type: "chart",
                    content: {
                      type: "bar",
                      series: completion.series.reverse(),
                      categories: ["수업 챕터 비중"],
                      rate: completion.rate,
                    },
                  },
                ]}
              /> */}
            </div>
          )}
          {learning && quiz && quiz.total > 0 && (
            <div className="bg-white p-4 rounded-lg">
              <h3 className="text-lg font-bold">퀴즈 리포트</h3>
              <div className="flex flex-col gap-1 mt-2">
                <div className="flex flex-row flex-wrap gap-1">
                  <div className="stat bg-zinc-100 rounded-md p-4 flex-grow flex-shrink basis-1/3">
                    <div className="stat-title opacity-100 font-bold">
                      총 퀴즈 결과
                    </div>
                    <div className="stat-value text-cyan-500 text-3xl">
                      <span className="text-4xl">{quiz.correct}</span>
                      <span className="align-sub text-zinc-600">{`/${quiz.total}`}</span>
                    </div>
                    <div className="stat-desc opacity-100">{`총 퀴즈 개수 중 정답 수`}</div>
                  </div>
                  <div className="stat bg-zinc-100 rounded-md p-4 flex-grow flex-shrink basis-1/2">
                    <div className="font-bold">퀴즈 정답율</div>
                    <div className="flex flex-row gap-2 items-center">
                      <div className="w-full h-8 rounded-full">
                        <Chart
                          {...{
                            type: "bar",
                            options: {
                              chart: {
                                id: "bar",
                                stacked: true,
                                stackType: "100%",
                                toolbar: {
                                  show: false,
                                },
                                sparkline: {
                                  enabled: true,
                                },
                                width: "100%",
                              },
                              colors: ["#82E4AB"],
                              fill: {
                                opacity: 1,
                              },
                              grid: {
                                show: false,
                              },
                              legend: {
                                show: false,
                              },
                              plotOptions: {
                                bar: {
                                  borderRadius: 8,
                                  horizontal: true,
                                  distributed: false,
                                  dataLabels: {
                                    total: {
                                      enabled: false,
                                    },
                                  },
                                },
                              },
                              dataLabels: {
                                enabled: false,
                              },
                              xaxis: {
                                labels: {
                                  show: false,
                                },
                              },
                              yaxis: {
                                labels: {
                                  show: false,
                                },
                              },
                            },
                            series: [
                              {
                                name: "퀴즈",
                                data: [
                                  {
                                    x: "",
                                    y: 100,
                                    goals: [
                                      {
                                        name: "퀴즈 정답율",
                                        value: quiz.rate,
                                        strokeWidth: 6,
                                        strokeHeight: 12,
                                        strokeColor: "#5F9FF5",
                                      },
                                    ],
                                  },
                                ],
                              },
                            ],
                          }}
                          height="100%"
                        />
                      </div>
                      <span className="font-semibold align-middle">{`${quiz.rate}%`}</span>
                    </div>
                  </div>
                </div>
                <div className="stat bg-zinc-100 rounded-md px-4">
                  <div className="stat-title opacity-100 font-bold">
                    퀴즈 결과 확인
                  </div>
                  <div className="flex justify-between flex-col">
                    {quiz.list.map(({ title, result }, idx) => (
                      <div
                        tabIndex={0}
                        className={`collapse rounded-md mb-1 bg-white`}
                        style={{
                          minHeight: "2.75rem",
                        }}
                        key={uuidv4()}
                      >
                        <div className="collapse-title-chapter inline-flex items-center justify-between gap-1">
                          {`${title}`}
                          <div
                            className={`w-7 text-center tracking-tighter leading-none border-b-4 border-double border-secondary`}
                          >
                            {result.score}
                          </div>
                        </div>
                        <div className="collapse-content-chapter p-0 pt-4">
                          {result && result.results && (
                            <div className="flex flex-col gap-2">
                              {result.results.map(
                                ({ q, a, type, result: r }, i) => (
                                  <div key={uuidv4()}>
                                    <Quiz
                                      {...{
                                        n: `${idx + 1}-${i + 1}`,
                                        option: type === "text",
                                        options:
                                          type === "text" || type === "textarea"
                                            ? false
                                            : a,
                                        q,
                                        answers:
                                          type === "text"
                                            ? a.value.split(", ")
                                            : a.reduce(
                                                (acc, { answer, content }) =>
                                                  answer
                                                    ? [...acc, content]
                                                    : acc,
                                                []
                                              ),
                                        response:
                                          type === "text"
                                            ? a.student
                                            : a.reduce(
                                                (acc, { response, content }) =>
                                                  response
                                                    ? [...acc, content]
                                                    : acc,
                                                []
                                              ),
                                        readOnly: true,
                                        type: type,
                                        result: r,
                                      }}
                                    />
                                  </div>
                                )
                              )}
                            </div>
                          )}
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 20 20"
                            fill="currentColor"
                            className="w-5 h-5 absolute bottom-0 left-0 right-0 m-auto mix-blend-difference"
                          >
                            <path
                              fillRule="evenodd"
                              d="M5.23 7.21a.75.75 0 011.06.02L10 11.168l3.71-3.938a.75.75 0 111.08 1.04l-4.25 4.5a.75.75 0 01-1.08 0l-4.25-4.5a.75.75 0 01.02-1.06z"
                              clipRule="evenodd"
                            />
                          </svg>
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
                <div className="stat bg-zinc-100 rounded-md p-4 flex-grow flex-shrink basis-1/3">
                  <div className="stat-title opacity-100 font-bold">
                    퀴즈 결과 비교 차트
                  </div>
                  <div className="flex flex-row gap-2 items-center">
                    {quiz.compare && (
                      <div className="w-full pb-8 relative">
                        <Chart
                          {...{
                            type: "radar",
                            options: {
                              chart: {
                                dropShadow: {
                                  enabled: true,
                                  blur: 1,
                                  left: 1,
                                  top: 1,
                                },
                                toolbar: {
                                  show: false,
                                },
                              },
                              colors: ["#5F9FF5", "#82E4AB"],
                              stroke: {
                                width: 2,
                              },
                              fill: {
                                opacity: 0.2,
                              },
                              markers: {
                                size: 0,
                              },
                              legend: {
                                show: false,
                              },
                              plotOptions: {
                                distributed: false,
                                radar: {
                                  offsetY: 0,
                                  polygons: {
                                    strokeColor: "#e8e8e8",
                                    fill: {
                                      colors: ["#fff"],
                                    },
                                  },
                                },
                              },
                              dataLabels: {
                                enabled: true,
                              },
                              xaxis: {
                                categories: quiz.compare.categories,
                              },
                              yaxis: {
                                show: false,
                              },
                            },
                            series: quiz.compare.series,
                          }}
                          width="100%"
                        />
                        <div className="absolute bottom-0 left-0 right-0 flex justify-center">
                          <div className="bg-white w-2/3 flex flex-wrap text-xs p-1 rounded-md justify-evenly md:justify-start">
                            <div className="inline-flex gap-2 items-center">
                              <div className="badge badge-xs bg-chart-0 border-chart-0"></div>
                              <span>{`${student.name} 학생 퀴즈 결과`}</span>
                            </div>
                            <div className="inline-flex gap-2 items-center">
                              <div className="badge badge-xs bg-chart-1 border-chart-1"></div>
                              <span>{`${lecture.name} 평균 퀴즈 결과`}</span>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              {/* <LearningRecord
                items={[
                  {
                    type: "stat",
                    content: {
                      title: "총 학습시간",
                      value: learning.times,
                      desc: `총 ${learning.hours}시간 수업 중 학습시간`,
                    },
                  },
                  {
                    type: "chart",
                    content: {
                      title: "퀴즈 정답율",
                      type: "bar",
                      series: {
                        name: "퀴즈",
                        goals: { name: "퀴즈 정답율", value: quiz.rate },
                      },
                    },
                  },
                ]}
              /> */}
            </div>
          )}
          {total && total.length > 0 && (
            <div className="bg-white p-4 rounded-lg">
              <h3 className="text-lg font-bold">종합 리포트</h3>
              <div className="stat bg-zinc-100 rounded-md px-4 mt-1">
                {total &&
                  total.map((v, i) => <p key={`report_sentence_${i}`}>{v}</p>)}
              </div>
              {/* <ComprehensiveEvaluation
              {...{
                subtitle: "학생이 가장 흥미를 가진 분야",
                keyword: "인공지능",
                desc: "수업과 활동을 단순하고 집중적으로 유지하면서 학생이 즐겁게 학습 과정을 즐기는지 확인해보세요. 이렇게 흥미진진한 AI 세계를 자연스럽게 이해하며 기술 및 컴퓨터 과학에 대한 추가 학습을 추구하도록 영감을 줄 수 있습니다.",
                items: [
                  {
                    type: "chart",
                    content: {
                      type: "radar",
                      categories: [
                        "데이터",
                        "프로그래밍",
                        "로봇 모션",
                        "로봇 제어",
                        "인공지능",
                      ],
                      series: [
                        {
                          name: "캠프 평균",
                          data: [20, 30, 40, 80, 20],
                        },
                        {
                          name: "파이보 학생",
                          data: [80, 50, 30, 40, 100],
                        },
                      ],
                    },
                  },
                ],
              }}
            /> */}
            </div>
          )}
          {!!parent_id && (
            <div className="stat bg-yellow-400 rounded-md p-4 flex-grow flex-shrink basis-1/3">
              <button
                onClick={() =>
                  window.open(
                    `/survey/response/${lecture_id}?target=parent`,
                    "_blank"
                  )
                }
              >
                <h3 className="font-bold text-lg flex justify-between">
                  <span>강의 만족도 설문조사</span>
                  <span>&gt;</span>
                </h3>
              </button>
              <div className="stat bg-yellow-100 rounded-md px-4 mt-1">
                <span>위의 버튼을 선택하여 설문조사 페이지로 이동합니다.</span>
                <span>설문조사 결과는 익명으로 전달됩니다.</span>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default ReportPage;
